import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@domun/component-library";
import { PhotoAiReferenceModalStyled } from "./photo-ai-reference-modal.styled";
import { ImageProductForm } from "@dashboard/modules/products/types/product-form.types";

interface PhotoAiReferenceModalProps {
  open: boolean;
  images: ImageProductForm[];
  selected: ImageProductForm | null;
  getPreviewSrc: (image: ImageProductForm) => string;
  onSelect: (image: ImageProductForm) => void;
  onConfirm: () => void;
  onClose: () => void;
}

const PhotoAiReferenceModal: FC<PhotoAiReferenceModalProps> = ({
  open,
  images,
  selected,
  getPreviewSrc,
  onSelect,
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <Modal
      title=""
      show={open}
      onClose={onClose}
      content={{
        className: "fadeInDown",
        styles: { overflow: "hidden", width: "480px" },
      }}
      header={{
        styles: {
          borderBottom: 0,
          boxShadow: "none",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 2,
        },
      }}
      body={{ styles: { padding: 0 } }}
    >
      <PhotoAiReferenceModalStyled>
        <h2>{t("productComponent.product.photoAi.referenceTitle")}</h2>
        <div className="grid">
          {images.map((image, index) => {
            const src = getPreviewSrc(image);
            const isActive = selected?.id === image.id && selected?.type === image.type;
            return (
              <button
                type="button"
                key={`ref-${image.type}-${image.id}-${index}`}
                className={`thumb ${isActive ? "active" : ""}`}
                onClick={() => onSelect(image)}
              >
                {src && <img src={src} alt="" />}
              </button>
            );
          })}
        </div>
        <div className="actions">
          <button type="button" className="secondary" onClick={onClose}>
            {t("productComponent.product.photoAi.cancel")}
          </button>
          <button
            type="button"
            className="primary"
            disabled={!selected}
            onClick={onConfirm}
          >
            {t("productComponent.product.photoAi.referenceConfirm")}
          </button>
        </div>
      </PhotoAiReferenceModalStyled>
    </Modal>
  );
};

export default PhotoAiReferenceModal;
